import { Controller, useFormContext } from "react-hook-form";
import { Form, TextArea } from "semantic-ui-react";

import type { FieldValues, Path } from "react-hook-form";
import type { FormFieldProps, TextAreaProps } from "semantic-ui-react";

type ShallowPath<T> = keyof T & string;

type TypeFormTextArea<T extends FieldValues> = {
  name: ShallowPath<T>;
  textAreaProps?: TextAreaProps;
  formFieldProps?: FormFieldProps;
};

export const FormTextArea = <T extends FieldValues>({ name, textAreaProps, formFieldProps }: TypeFormTextArea<T>) => {
  const methods = useFormContext<T>();

  return (
    <Controller
      name={name as Path<T>}
      {...methods}
      render={({ field, fieldState: { invalid, isTouched } }) => (
        <Form.Field {...formFieldProps} error={invalid && isTouched}>
          <TextArea {...methods.register(name as Path<T>)} {...field} {...textAreaProps} />
        </Form.Field>
      )}
    />
  );
};
